import { Box, BoxProps, styled, Theme } from "@mui/material";

import { DARK_SCHEME, scrimOver } from "../../../theme/dark-scheme-css";

// Left literal on purpose: stops 2 and 3 (#0078A2, #4FB3CD) both map to the
// supporting teal token, so converting would collapse the gradient to a single
// teal, which is a design question.
const RFP_BANNER_GRADIENT =
  "linear-gradient(89.89deg, #832A80 38.88%, #0078A2 105.32%, #4FB3CD 139.34%)";

const RFPBannerRoot = styled(Box)(({ theme }: { theme: Theme }) => ({
  background: RFP_BANNER_GRADIENT,
  padding: theme.spacing(1, 0),
  ".MuiTypography-root": {
    color: theme.palette.common.white,
    fontWeight: 500,
  },
  [DARK_SCHEME]: {
    backgroundImage: scrimOver(RFP_BANNER_GRADIENT),
  },
}));

export const RFP_BANNER_TEST_ID = "rfp-banner";

export const RFPBanner = (props: BoxProps): React.JSX.Element => (
  <RFPBannerRoot data-testid={RFP_BANNER_TEST_ID} {...props} />
);
